import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Button,
    Modal,
    Form,
    Popup,
    Icon,
    Input,
    Checkbox,
    Message,
    Dropdown,
    Grid
} from "semantic-ui-react";
import "../Create_User/CreateUser.css";
import DEFAULTS from "../../../Constants/lookupDefaultValues";
import setDropdownValues from "../../../Common/Utility/setDropdownValues";
import resetSelectAllCheckbox from "../../../Common/Utility/resetSelectAllCheckbox";
import * as actions from "../../../actions/users/getUserActions";
//import moment from "moment";
import { bindActionCreators } from "redux";
import {
    createNotification,
    NOTIFICATION_TYPE_SUCCESS,
    NOTIFICATION_TYPE_ERROR
} from "react-redux-notify";
import svg_icon_path from "../../../static/media/SVGSpriteIcon.svg";
//import API from "../../../Constants/API";
//import * as usersServices from "../../../services/users/index";

var userDetails = atob(localStorage.getItem("userDetails"));

if (userDetails) {
    try {
        userDetails = JSON.parse(userDetails);
    }
    catch (error) {
        console.error('Invalid JSON input:', error.message);
    }
}
//  let logindetails = this.getFullName(userDetails.UserContext);
var FIRM_ID = userDetails ? userDetails.UserContext.firmId : 847;
var logginedUser = userDetails.UserContext.userId;

//Check globale user
//console.log(userDetails, userDetails.Rights);
let rightsDetails = userDetails.Rights.filter(x => x.module_id == 8);
let BRANCH_ID = userDetails.UserContext.locationId;
let RIGHT_ACCESS = rightsDetails[0].access;
let MODULE_ID = rightsDetails[0].module_id;
let GLOBAL_USER = "N";
if (RIGHT_ACCESS == 1 && MODULE_ID == 8) {
    GLOBAL_USER = "Y";
}

class BulkEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.shouldModalOpen,
      selectedFirmBranchesId: GLOBAL_USER === "Y" ? "" : BRANCH_ID,
      selectedDepartmentIds: [],
      selectedDepartmentIdsError: false,
      selectedTaskLocationsIds: [],
      selectedTaskLocationsIdsError: false,
      selectedRightGroupsIds: [],
      selectedRightGroupsIdsError: false,
      selectedPageDetailsIds: [],
      selectedPageDetailsIdsError: false,
      // selectedPageDetailsIdsMaxError: false,
      selectedDefaultMyviewId: "",
      selectedTitleLevelListIds: "",
      selectedIndustryIds: [],
      selectedIndustryIdsError: false,
      selectedExpertiseIds: [],
      selectedExpertiseIdsError: false,
      selectedNicheGroupsIds: [],
      selectedNicheGroupsIdsError: false,
      selectedPrimaryRoleId: "",
      selectedSecondaryRoleId: "",
      ipInputs: [{ fromIP: "", toIP: "" }],
      isError: true,
      // FirmBranchesIdError: false,
      ipInputsError: false,
      finalIpAddress: "",
      error_signal: false,
      ip_error_msg: ""
    };
  }
  addIPClick() {
    this.setState(prevState => {
      let nextState = Object.assign({}, prevState);
      if (nextState.ipInputs.length <= 4)
        nextState.ipInputs.push({ fromIP: "", toIP: "" });
      return nextState;
      //ipInputs: [...prevState.ipInputs, { fromIP: "", toIP: "" }]
    });
  }
  createUI() {
    return this.state.ipInputs.map((el, i) => (
      <Grid.Row key={i}>
        <Grid.Column width={6}>
          <Input
            fluid
            name="fromIP"           
            className={this.state.ipInputs[i].fromIP.length ? "edited" : ""}
            error={this.state.ipInputsError}
            placeholder=""
            value={this.state.ipInputs.fromIP}
            onChange={this.ipHandleChange.bind(this, i)}
          />
        </Grid.Column>
        <Grid.Column width={1} verticalAlign="middle">
          -
        </Grid.Column>

        <Grid.Column width={6}>
          <Input
            fluid
            name="toIP"
            className={this.state.ipInputs[i].toIP.length ? "edited" : ""}
            error={this.state.ipInputsError}
            value={this.state.ipInputs.toIP}
            placeholder=""
            onChange={this.ipHandleChange.bind(this, i)}
          />
        </Grid.Column>
        <Grid.Column width={2} verticalAlign="middle">
          <Popup
            content="Delete the IP address range."
            position="top right"
            trigger={
              <svg className={i === 0 ? "hide" : "svg_icon xcm-icon-close size-24 red"}
                disabled={i === 0}
                onClick={this.removeIpClick.bind(this, i)}>
                <use xlinkHref={`${svg_icon_path}#xcm-icon-close`}> </use>
              </svg>
            }
          />
        </Grid.Column>
      </Grid.Row>
    ));
  }

    removeIpClick(i) {
        let ipInputs = [...this.state.ipInputs];
        ipInputs.splice(i, 1);
        this.setState({ ipInputs });
    }

    onFirmBranchesChange(ev, data) {
        let selectedFirmBranchesId = data.value;
        this.setState({
            selectedFirmBranchesId
            // FirmBranchesIdError: false
        });
    }

    onTaskLocationsChange(ev, data) {

        let selectedTaskLocationsIds = data.value;
        if (Array.isArray(selectedTaskLocationsIds) && selectedTaskLocationsIds.includes(0)) {
            this.setState({ selectedTaskLocationsIdsError: true, selectedTaskLocationsIds: [0] });
        } else {
            this.setState({
                selectedTaskLocationsIdsError: false,
                selectedTaskLocationsIds
            });
        }
    }

    onDepartmentChange(ev, data) {
        let selectedDepartmentIds = data.value;
        if (Array.isArray(selectedDepartmentIds) && selectedDepartmentIds.includes(0)) {
            this.setState({ selectedDepartmentIdsError: true, selectedDepartmentIds: [0] });
        } else {
            this.setState({
                selectedDepartmentIdsError: false,
                selectedDepartmentIds
            });
        }
    }

    onRightsGroupsNamesChange(ev, data) {
        let selectedRightGroupsIds = data.value;
        if (Array.isArray(selectedRightGroupsIds) && selectedRightGroupsIds.includes(0)) {
            this.setState({ selectedRightGroupsIdsError: true, selectedRightGroupsIds: [0] });
        } else {
            this.setState({
                selectedRightGroupsIdsError: false,
                selectedRightGroupsIds
            });
        }

        // this.setState({
        //   selectedRightGroupsIds
        // });
    }
    onPageDetailsChange(ev, data) {
        let selectedPageDetailsIds = data.value;
        if (selectedPageDetailsIds.length && selectedPageDetailsIds.length < 8) {
            this.setState({
                // selectedPageDetailsIdsMaxError: false,
                selectedPageDetailsIds,
                selectedDefaultMyviewId: "0"
            });
        }

        // this.setState({
        //   selectedPageDetailsIds
        // });
    }
    onDefaultMyviewChange(ev, data) {
        let selectedDefaultMyviewId = data.value;
        this.setState({
            selectedDefaultMyviewId
        });
    }

    onTitleLevelListChange(ev, data) {
        let selectedTitleLevelListIds = data.value;
        this.setState({
            selectedTitleLevelListIds
        });
    }
    onIndustryChange(ev, data) {
        let selectedIndustryIds = data.value;
        if (Array.isArray(selectedIndustryIds) && selectedIndustryIds.includes(0)) {
            this.setState({ selectedIndustryIdsError: true, selectedIndustryIds: [0] });
        } else {
            this.setState({
                selectedIndustryIdsError: false,
                selectedIndustryIds
            });
        }

        // this.setState({
        //   selectedIndustryIds
        // });
    }
    onNicheGroupsChange(ev, data) {
        let selectedNicheGroupsIds = data.value;
        if (Array.isArray(selectedNicheGroupsIds) && selectedNicheGroupsIds.includes(0)) {
            this.setState({ selectedNicheGroupsIdsError: true, selectedNicheGroupsIds: [0] });
        } else {
            this.setState({
                selectedNicheGroupsIdsError: false,
                selectedNicheGroupsIds
            });
        }

        // this.setState({
        //   selectedNicheGroupsIds
        // });
    }

    onExpertiseChange(ev, data) {
        let selectedExpertiseIds = data.value;
        if (Array.isArray(selectedExpertiseIds) && selectedExpertiseIds.includes(0)) {
            this.setState({ selectedExpertiseIdsError: true, selectedExpertiseIds: [0] });
        } else {
            this.setState({
                selectedExpertiseIdsError: false,
                selectedExpertiseIds
            });
        }
        // this.setState({
        //   selectedExpertiseIds
        // });
    }
    onPrimaryRoleChange(ev, data) {
        let selectedPrimaryRoleId = data.value;
        this.setState({
            selectedPrimaryRoleId
        });
    }
    onSecondaryRoleChange(ev, data) {
        let selectedSecondaryRoleId = data.value;
        this.setState({
            selectedSecondaryRoleId
        });
    }

    // dynamically set dafualu view options based on selected pinned views

    defaultViewOptions = () => {
        let pageDetails = setDropdownValues(
            {
                data: this.props.lookup,
                defaults: DEFAULTS,
                selector: "pageDetails",
                properties: { key: "id", value: "id", text: "name" }
            },
            "fromBulkEdit"
        );

        let selectedPinnnedViews = this.state.selectedPageDetailsIds;
        let optionsForDefaultView = pageDetails ? pageDetails.filter((pd) => selectedPinnnedViews.includes(pd.value)) : [];
        // console.log("selectedPinnnedViews", pageDetails, selectedPinnnedViews, optionsForDefaultView)
        // if (selectedPinnnedViews.includes(0)) {
        //   return optionsForDefaultView ? [{ key: 0, value: 0, text: "Blank" }] : []
        // } else {
        //   return optionsForDefaultView ? [{ key: 0, value: 0, text: "Blank" }, ...optionsForDefaultView] : []
        // }

        return optionsForDefaultView;
    }


    ipHandleChange(i, e) {
        const { name, value } = e.target;
        e.target.value = e.target.value.replace(/[^0-9\.]/g, "");
        let ipInputs = [...this.state.ipInputs];
        ipInputs[i] = { ...ipInputs[i], [name]: value };
        this.setState({ ipInputs });
    }

    ValidateIPaddress(inputText) {
        let ipps = [];
        //let ipRange = "";
        var ipregex = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
        return inputText.map(x => {
            if (x.toIP.length && !x.fromIP.length) return false;
            if (x.fromIP.length != 0) {
                let _testfrom = ipregex.test(x.fromIP);
                let _testto = true;
                if (x.toIP.length) _testto = ipregex.test(x.toIP);

                if (_testfrom && _testto) {
                    if (x.toIP.length) {
                        let _tolist = x.toIP.split(".");
                        return x.fromIP.split(".").map((y, i) => {
                            let _res = parseInt(y, 10) - parseInt(_tolist[i], 10);
                            if (i != 3) {
                                return _res !== 0 ? false : true;
                            } else {
                                return _res > 0 ? false : true;
                            }
                        });
                    } else return true;
                } else return false;
            } else return true;
        });
    }

    updateData(updatedDataObj) {
        this.props.actions
            .bulkUpdateUsers(updatedDataObj, this.props.allUsers, this.props.lookup)
            // .then(() => {
            //   this.props.actions.getAllUsers(
            //     FIRM_ID,
            //     BRANCH_ID,
            //     GLOBAL_USER,
            //     this.props.lookup
            //   );
            // })
            .then((request) => {
                if (request.isSuccess) {
                    const bulkUpdateNotification = {
                        message: "Bulk update successful",
                        type: NOTIFICATION_TYPE_SUCCESS,
                        duration: 5000,
                        canDismiss: true,
                        showCloseAllBtn: true
                    };
                    this.props.actions.resetLoading(false);
                    this.props.createNotification(bulkUpdateNotification);
                }
                else {
                    const notification = {
                        message: request.msg,
                        type: NOTIFICATION_TYPE_ERROR,
                        duration: 5000,
                        canDismiss: true,
                        showCloseAllBtn: true
                    };
                    this.props.createNotification(notification);
                    this.props.actions.resetLoading(false);
                    this.props.actions.discardChanges();
                    this.state.activatedUsersList = [];

                }
            });
        resetSelectAllCheckbox();
        this.resetState();
        this.props.toggleBulkEditForm();
    }
    onCancel() {
        this.props.toggleBulkEditForm();
        this.resetState();
    }
    onUpdateChanges() {
        let error = false;
        let errVals = {
            // FirmBranchesIdError: false,
            ipInputsError: false
        };

        let ipRange = this.state.ipInputs ? this.state.ipInputs : "";
        let ipValidator = this.ValidateIPaddress(ipRange);

        let finalIpRange;
        let ipError = false;
        // if (this.state.selectedFirmBranchesId === "") {
        //   errVals.FirmBranchesIdError = true;
        // }

        ipValidator.map((xx, ii) => {
            if (typeof xx === "object") {
                if (xx.includes(false)) {
                    ipError = true;
                    return ii;
                }
            } else ipError = ipError ? ipError : !xx;
        });

        if (!ipError) {
            var _dup = [];

            ipRange.map(xx => {
                let _f = parseInt(xx.fromIP.split(".")[3]);
                let _t = parseInt(xx.toIP.split(".")[3]);

                let _ii = parseInt(_t) - parseInt(_f);

                if (!isNaN(_ii)) {
                    for (var _i = _f; _i <= _t; _i++) {
                        _dup.push(
                            xx.fromIP
                                .split(".")
                                .slice(0, 3)
                                .join(".") +
                            "." +
                            _i
                        );
                    }
                } else _dup.push(xx.fromIP);

                return;
            });

            if (_dup.length) {
                new Set(_dup).size === _dup.length
                    ? (errVals.ipInputsError = false)
                    : (errVals.ipInputsError = true);
            }
            if (!errVals.ipInputsError) {
                finalIpRange = ipRange
                    .map(x => {
                        if (!x.toIP) return x.fromIP;
                        else {
                            return x.fromIP + "-" + x.toIP.split(".")[3];
                        }
                    })
                    .join(",");
                this.setState({ finalIpAddress: finalIpRange });
                errVals.ipInputsError = false;
                this.setState({ error_signal: false });
            } else {
                // error = true;
                errVals.ipInputsError = true;
                this.setState({ error_signal: true, ip_error_msg: "* IP Range already exist" });
            }
        } else {
            errVals.ipInputsError = true;
            this.setState({ error_signal: true, ip_error_msg: "* Enter valid IP address/range" });
        }
        if (errVals.ipInputsError) {
            //error = true;
            this.setState({ ...errVals });
            // this.setState({ error_signal: false });
            return;
        }

        var updatedDataObj = {
            useriddetail: this.props.selectedUsersIds.join(),
            branch_id:
                this.state.selectedFirmBranchesId == ""
                    ? "0"
                    : this.state.selectedFirmBranchesId,
            branch_name: this.state.selectedFirmBranchesId == ""
                ? ""
                : this.props.lookup.firmBranches.find(x => x.branch_id == this.state.selectedFirmBranchesId).branch_name,    
            department: this.state.selectedDepartmentIds.join(),
            task_Locations: this.state.selectedTaskLocationsIds.join(),
            belongsto_group: this.state.selectedRightGroupsIds.join(),
            page_id: this.state.selectedPageDetailsIds.join(),
            landingPageId: this.state.selectedDefaultMyviewId,
            title_level: this.state.selectedTitleLevelListIds,
            industry_group: this.state.selectedIndustryIds.join(),
            niche_group: this.state.selectedNicheGroupsIds.join(),
            expertise: this.state.selectedExpertiseIds.join(),
            primary_role: this.state.selectedPrimaryRoleId,
            secondary_role: this.state.selectedSecondaryRoleId,
            ip_from: finalIpRange,
            loggedUserId: logginedUser
        };

        if (!error) {
            // var pageId = updatedDataObj.landingPageId
            //   ? updatedDataObj.page_id
            //     ? updatedDataObj.landingPageId
            //         .toString()
            //         .concat(",", updatedDataObj.page_id)
            //     : updatedDataObj.landingPageId.toString()
            //   : updatedDataObj.page_id;

            // updatedDataObj.page_id = [...new Set(pageId.split(","))].join();
            this.props.actions.resetLoading(true);
            this.updateData(updatedDataObj);
        }
    }
    resetState() {
        this.setState({
            selectedFirmBranchesId: GLOBAL_USER === "Y" ? "" : BRANCH_ID,
            selectedDepartmentIds: [],
            selectedDepartmentIdsError: false,
            selectedTaskLocationsIds: [],
            selectedTaskLocationsIdsError: false,
            selectedRightGroupsIds: [],
            selectedRightGroupsIdsError: false,
            selectedPageDetailsIds: [],
            selectedPageDetailsIdsError: false,
            selectedDefaultMyviewId: "",
            selectedTitleLevelListIds: "",
            selectedIndustryIds: [],
            selectedIndustryIdsError: false,
            selectedExpertiseIds: [],
            selectedExpertiseIdsError: false,
            selectedNicheGroupsIds: [],
            selectedNicheGroupsIdsError: false,
            selectedPrimaryRoleId: "",
            selectedSecondaryRoleId: "",
            ipInputs: [{ fromIP: "", toIP: "" }],
            isError: true,
            // FirmBranchesIdError: false,
            ipInputsError: false,
            finalIpAddress: "",
            error_signal: false,
            ip_error_msg: "",
        });
    }

    componentDidMount() {
        window.onbeforeunload = () => {
            if (this.props.isEdited) {
                return "";
            }
        };
        this.firmLookUpDetails = this.props.actions.fetchfirmLookUpDetails(FIRM_ID);
    }

    render() {
        // let { lookup } = this.props;
        return (
            <Modal
                size={"fullscreen"}
                className={"bulkEditModal"}
                centered={false}
                open={this.props.shouldModalOpen}
            >
                <Modal.Header>
                    <Grid columns={2}>
                        <Grid.Row>
                            <Grid.Column width={14}>
                                <h2> Bulk Edit</h2>
                            </Grid.Column>
                            <Grid.Column width={2} style={{ textAlign: "right" }}>
                                <Icon
                                    className="xcm-icon-close size-24"
                                    style={{ cursor: "pointer" }}
                                    onClick={this.onCancel.bind(this)}
                                />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Header>
                <Modal.Content>
                    <Form>
                        <Grid columns={4}>
                            <Grid.Row>
                                <Grid.Column width={3}>
                                    <Form.Field>
                                        <label> Primary Location {/* <Popup
                      content="This field is a single select dropdown. The existing data will be replaced with the data entered, even if the setting is set to append."
                      trigger={
                        <Icon
                          className="xcm-icon-exclamation v-align-bottom orange"
                          size="large"
                        ></Icon>
                      }
                    /> */ }</label>

                                    </Form.Field>
                                </Grid.Column>
                                <Grid.Column width={5}>
                                    <Dropdown
                                        fluid
                                        placeholder="Select"
                                        search
                                        selectOnBlur={false}
                                        clearable
                                        // required={true}
                                        // error={this.state.FirmBranchesIdError}
                                        selection
                                        className={this.state.selectedFirmBranchesId.toString() ? "edited" : ""}
                                        disabled={GLOBAL_USER === "Y" ? false : true}
                                        value={
                                            GLOBAL_USER === "Y"
                                                ? this.state.selectedFirmBranchesId
                                                : BRANCH_ID
                                        }
                                        options={
                                            setDropdownValues({
                                                data: this.props.lookup,
                                                defaults: DEFAULTS,
                                                selector: "firmBranches",
                                                properties: { key: "id", value: "id", text: "name" }
                                            }) || []
                                        }
                                        onChange={this.onFirmBranchesChange.bind(this)}
                                    />
                                </Grid.Column>
                                <Grid.Column width={3}>Department</Grid.Column>
                                <Grid.Column width={5}>
                                    <Dropdown
                                        fluid
                                        placeholder="Select"
                                        search
                                        clearable
                                        multiple
                                        selection
                                        value={this.state.selectedDepartmentIdsError ? [0] : this.state.selectedDepartmentIds}
                                        className={this.state.selectedDepartmentIds.length ? "edited" : ""}
                                        options={
                                            setDropdownValues(
                                                {
                                                    data: this.props.lookup,
                                                    defaults: DEFAULTS,
                                                    selector: "department",
                                                    properties: { key: "id", value: "id", text: "name" }
                                                },
                                                "fromBulkEdit"
                                            ) || []
                                        }
                                        onChange={this.onDepartmentChange.bind(this)}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={3}>
                                    <label> Task Locations</label>
                                </Grid.Column>
                                <Grid.Column width={5}>
                                    <Dropdown
                                        fluid
                                        placeholder="Select"
                                        search
                                        clearable
                                        multiple
                                        selection
                                        value={this.state.selectedTaskLocationsIdsError ? [0] : this.state.selectedTaskLocationsIds}
                                        className={this.state.selectedTaskLocationsIds.length ? "edited" : ""}
                                        options={
                                            setDropdownValues(
                                                {
                                                    data: this.props.lookup,
                                                    defaults: DEFAULTS,
                                                    selector: "firmBranches",
                                                    properties: { key: "id", value: "id", text: "name" }
                                                },
                                                "fromBulkEdit"
                                            ) || []
                                        }
                                        onChange={this.onTaskLocationsChange.bind(this)}
                                    />
                                </Grid.Column>
                                <Grid.Column width={3}>User Group</Grid.Column>
                                <Grid.Column width={5}>
                                    <Dropdown
                                        fluid
                                        placeholder="Select"
                                        search
                                        clearable
                                        multiple
                                        selection
                                        value={this.state.selectedRightGroupsIdsError ? [0] : this.state.selectedRightGroupsIds}
                                        className={this.state.selectedRightGroupsIds.length ? "edited" : ""}

                                        options={
                                            setDropdownValues(
                                                {
                                                    data: this.props.lookup,
                                                    defaults: DEFAULTS,
                                                    selector: "rightsGroupNames",
                                                    properties: { key: "id", value: "id", text: "name" }
                                                },
                                                "fromBulkEdit"
                                            ) || []
                                        }
                                        onChange={this.onRightsGroupsNamesChange.bind(this)}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={3}>Pinned Views for MyView
                <Popup
                    content="Users can have up to 7 views pinned to their MyView."
                    trigger={
                      <svg className={`svg_icon xcm-icon-info size-20 orange ml-4`}>
                                                <use xlinkHref={`${svg_icon_path}#xcm-icon-info`}> </use>
                                            </svg>
                    }
                  />
                  {/* {this.state.selectedPageDetailsIdsMaxError
                    ? <Message negative>
                      <p>You can select upto 7 options only</p>
                    </Message>
                    : ""} */}
                                </Grid.Column>
                                <Grid.Column width={5}>
                                    <Dropdown
                                        fluid
                                        placeholder="Select"
                                        search
                                        clearable
                                        multiple
                                        selection
                                        value={this.state.selectedPageDetailsIds}
                                        className={this.state.selectedPageDetailsIds.length ? "edited" : ""}

                                        options={
                                            setDropdownValues(
                                                {
                                                    data: this.props.lookup,
                                                    defaults: DEFAULTS,
                                                    selector: "pageDetails",
                                                    properties: { key: "id", value: "id", text: "name" }
                                                },
                                                "fromBulkEdit"
                                            ) || []
                                        }
                                        onChange={this.onPageDetailsChange.bind(this)}
                                    />
                                </Grid.Column>
                                <Grid.Column width={3}>Default MyView View</Grid.Column>
                                <Grid.Column width={5}>
                                    <Dropdown
                                        fluid
                                        placeholder="Select"
                                        selectOnBlur={false}
                                        search
                                        clearable
                                        selection
                                        className={this.state.selectedDefaultMyviewId.toString() && this.state.selectedDefaultMyviewId.toString() !== "0" ? "edited" : ""}
                                        options={this.defaultViewOptions()}
                                        // options={
                                        //   setDropdownValues(
                                        //     {
                                        //       data: this.props.lookup,
                                        //       defaults: DEFAULTS,
                                        //       selector: "pageDetails",
                                        //       properties: { key: "id", value: "id", text: "name" }
                                        //     },
                                        //     "fromBulkEdit"
                                        //   ) || []
                                        // }
                                        onChange={this.onDefaultMyviewChange.bind(this)}
                                    />
                                </Grid.Column>


                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={3}>Title/Level</Grid.Column>
                                <Grid.Column width={5}>
                                    <Dropdown
                                        fluid
                                        placeholder="Select"
                                        selectOnBlur={false}
                                        search
                                        clearable
                                        selection
                                        className={`${((this.props.firmLookUpDetails.axcessIntegrationEnabled == false && (this.props.firmLookUpDetails.axcessIntegrationDate == "" || this.props.firmLookUpDetails.axcessIntegrationDate == null))
                                            || (this.props.firmLookUpDetails.axcessIntegrationEnabled == true && (this.props.firmLookUpDetails.axcessIntegrationDate == "" || this.props.firmLookUpDetails.axcessIntegrationDate == null))) ?
                                            (this.state.selectedTitleLevelListIds.toString()
                                                ? "edited"
                                                : "")
                                            : "wkuserdetailsdisabled"
                                            }`}
                                        options={
                                            setDropdownValues(
                                                {
                                                    data: this.props.lookup,
                                                    defaults: DEFAULTS,
                                                    selector: "titleLevelList",
                                                    properties: { key: "id", value: "id", text: "name" }
                                                },
                                                "fromBulkEdit"
                                            ) || []
                                        }
                                        onChange={this.onTitleLevelListChange.bind(this)}
                                    />
                                </Grid.Column>

                                <Grid.Column width={3}>Industry Group</Grid.Column>
                                <Grid.Column width={5}>
                                    <Dropdown
                                        fluid
                                        placeholder="Select"
                                        search
                                        clearable
                                        multiple
                                        selection
                                        value={this.state.selectedIndustryIdsError ? [0] : this.state.selectedIndustryIds}
                                        className={this.state.selectedIndustryIds.length ? "edited" : ""}

                                        options={
                                            setDropdownValues(
                                                {
                                                    data: this.props.lookup,
                                                    defaults: DEFAULTS,
                                                    selector: "industry",
                                                    properties: { key: "id", value: "id", text: "name" }
                                                },
                                                "fromBulkEdit"
                                            ) || []
                                        }
                                        onChange={this.onIndustryChange.bind(this)}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={3}>Niche Group</Grid.Column>
                                <Grid.Column width={5}>
                                    <Dropdown
                                        fluid
                                        placeholder="Select"
                                        search
                                        clearable
                                        multiple
                                        selection
                                        value={this.state.selectedNicheGroupsIdsError ? [0] : this.state.selectedNicheGroupsIds}
                                        className={this.state.selectedNicheGroupsIds.length ? "edited" : ""}

                                        options={
                                            setDropdownValues(
                                                {
                                                    data: this.props.lookup,
                                                    defaults: DEFAULTS,
                                                    selector: "nicheGroups",
                                                    properties: { key: "id", value: "id", text: "name" }
                                                },
                                                "fromBulkEdit"
                                            ) || []
                                        }
                                        onChange={this.onNicheGroupsChange.bind(this)}
                                    />
                                </Grid.Column>

                                <Grid.Column width={3}>Expertise</Grid.Column>
                                <Grid.Column width={5}>
                                    <Dropdown
                                        fluid
                                        placeholder="Select"
                                        search
                                        clearable
                                        multiple
                                        selection
                                        value={this.state.selectedExpertiseIdsError ? [0] : this.state.selectedExpertiseIds}
                                        className={`${((this.props.firmLookUpDetails.axcessIntegrationEnabled == false && (this.props.firmLookUpDetails.axcessIntegrationDate == "" || this.props.firmLookUpDetails.axcessIntegrationDate == null))
                                            || (this.props.firmLookUpDetails.axcessIntegrationEnabled == true && (this.props.firmLookUpDetails.axcessIntegrationDate == "" || this.props.firmLookUpDetails.axcessIntegrationDate == null))) ?
                                            (this.state.selectedExpertiseIds.length
                                                ? "edited"
                                                : "")
                                            : "wkuserdetailsdisabled"
                                            }`}
                                        options={
                                            setDropdownValues(
                                                {
                                                    data: this.props.lookup,
                                                    defaults: DEFAULTS,
                                                    selector: "expertise",
                                                    properties: { key: "id", value: "id", text: "name" }
                                                },
                                                "fromBulkEdit"
                                            ) || []
                                        }
                                        onChange={this.onExpertiseChange.bind(this)}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={3}>Primary Role</Grid.Column>
                                <Grid.Column width={5}>
                                    <Dropdown
                                        key={"primary_role"}
                                        fluid
                                        placeholder="Select"
                                        selectOnBlur={false}
                                        search
                                        clearable
                                        selection
                                        className={this.state.selectedPrimaryRoleId.toString() ? "edited" : ""}

                                        options={
                                            setDropdownValues(
                                                {
                                                    data: this.props.lookup,
                                                    defaults: DEFAULTS,
                                                    selector: "rolesDetails",
                                                    properties: { key: "id", value: "id", text: "name" }
                                                },
                                                "fromBulkEdit"
                                            ) || []
                                        }
                                        onChange={this.onPrimaryRoleChange.bind(this)}
                                    />
                                </Grid.Column>
                                <Grid.Column width={3}>Secondary Role</Grid.Column>
                                <Grid.Column width={5}>
                                    <Dropdown
                                        key={"secondary_role"}
                                        fluid
                                        selectOnBlur={false}
                                        placeholder="Select"
                                        search
                                        clearable
                                        selection
                                        className={this.state.selectedSecondaryRoleId.toString() ? "edited" : ""}

                                        options={
                                            setDropdownValues(
                                                {
                                                    data: this.props.lookup,
                                                    defaults: DEFAULTS,
                                                    selector: "rolesDetails",
                                                    properties: { key: "id", value: "id", text: "name" }
                                                },
                                                "fromBulkEdit"
                                            ) || []
                                        }
                                        onChange={this.onSecondaryRoleChange.bind(this)}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={3}>
                                    <label className="middle aligned">IP Address Restriction Range
                  <Popup
                      content="Enter the first field to restrict access to a single IP address, or both to enter an IP address range."
                      trigger={
                        <svg className={`svg_icon xcm-icon-info size-20 orange ml-4`}>
                                                    <use xlinkHref={`${svg_icon_path}#xcm-icon-info`}> </use>
                                                </svg>
                      }
                    /></label>
                </Grid.Column>
                <Grid.Column width={5}>
                  <Grid columns={4}>
                    {this.createUI()}

                                        <Grid.Row>
                                            <Grid.Column width={7}>
                                                <Button basic onClick={this.addIPClick.bind(this)}>
                                                    <Icon name="plus" /> Add New
                        </Button>
                                                <div
                                                    className={`errmsg errorEmail ${this.state.error_signal ? "errshow" : "errhide"
                                                        }`}
                                                >
                                                    {this.state.ip_error_msg}
                                                </div>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Form>
                    {/*  <p style={{ color: "red" }}>Please note: Changes applied to fields that are single select dropdowns will always replace the existing data, even if the setting is set to append.</p> */}
                </Modal.Content>

                <Modal.Actions>

                    { /* <Checkbox toggle label='Replace'
            floated='left'
            // onChange={this.toggle}
            style={{ float: "left" }}
          /> */}
          <Button
            
            content="Cancel"
            
            onClick={this.onCancel.bind(this)}
          />
          <Button
            content="Update"
            primary
            onClick={this.onUpdateChanges.bind(this)}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
    //console.log("checking mapStateToPropsBulkedit", state);
    return {
        lookup: state.userReducer.lookupData,
        selectedUsersIds: state.userReducer.selectedUsers.selectedUsersIds,
        allUsers: state.userReducer.allUsers,
        firmLookUpDetails: state.userReducer.firmLookUpDetails
    };
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch),
    createNotification: config => {
        dispatch(createNotification(config));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BulkEdit);
